module.exports = __webpack_public_path__ + "fonts/iconfont.23039658.eot";